import _ from "lodash";
import { getBehaviourColourForPosition } from "@signolteam/shared/colours";
import { formatMass } from "@signolteam/shared/units-of-measure";
import { convertFuelBurnedToCo2 } from "@signolteam/shared/utils";
import { Tag } from "@src/components/atoms";
import AppUtils from "@src/utils/appUtils";

/** Tags of per-behaviour co2 savings eg. "ABC savings: 123 MT"
 * @param {{
 *   industry: string;
 *   customerBehaviours: Array<{behaviourAcronym: string, behaviourName: string, order: number}>
 *   operatorSingleYearImpact: { impactPerBvr: Array<{year: string, behaviourGroupCode: string, donationsPerYear: number, fuelSavedPerYear: number}> }
 * }} props
 */
const PersonalAnnualCarbonTags = ({
  industry,
  customerBehaviours,
  operatorSingleYearImpact,
}) => {
  const { impactPerBvr } = operatorSingleYearImpact;
  const bvrAcronymToOrder = customerBehaviours.reduce((acc, obj) => {
    acc[obj.behaviourAcronym] = obj.order;
    return acc;
  }, {});

  let fuelSavingsPerBvr = _(impactPerBvr)
    .map((item) => ({
      ...item,
      order: bvrAcronymToOrder[item.behaviourGroupCode],
    }))
    .groupBy((item) => item.behaviourGroupCode)
    .map((items, groupCode) => {
      const order = bvrAcronymToOrder[groupCode];
      const totalSavings = _.sumBy(items, "fuelSavedPerYear");
      return {
        behaviourGroupCode: groupCode,
        order,
        co2kg: convertFuelBurnedToCo2(totalSavings),
      };
    })
    .sortBy("order")
    .value();

  fuelSavingsPerBvr = fuelSavingsPerBvr.filter(
    (item) =>
      !AppUtils.isFeatureAvailableForBehaviour(
        "BehaviourWithNoFuelSavings",
        item.behaviourGroupCode,
      ),
  );

  //TODO - Replace by dynamic content when DC field fixed
  const tags = fuelSavingsPerBvr.map((item) => (
    <Tag
      color={getBehaviourColourForPosition(item.order).name}
      block
      key={item.behaviourGroupCode}
      fullWidth
    >
      <div className="flex justify-between">
        <span>{`${item.behaviourGroupCode} savings:`}</span>
        <strong>{formatMass(industry, item.co2kg).formattedValue}</strong>
      </div>
    </Tag>
  ));

  return (
    <div className="flex flex-col gap-2 text-left justify-start">{tags}</div>
  );
};
export default PersonalAnnualCarbonTags;
